import { h } from 'vue';
const boundaryDetectorStyle = {
    height: '0 !important',
    margin: '0 !important',
    padding: '0 !important',
    border: 'none !important',
    outline: 'none !important',
};

export default {
    props: {
        tag: {
            type: String,
            default: 'div',
        },
        overflowClass: {
            type: String,
            default: 'is-overflowing',
        },
    },
    data() {
        return {
            topBoundaryVisible: true,
            bottomBoundaryVisible: true,
        };
    },
    render() {
        this.topBoundary = h('div', { style: boundaryDetectorStyle });
        this.bottomBoundary = h('div', { style: boundaryDetectorStyle });

        return h(this.tag, {
            class: this.isOverflowing ? [this.overflowClass] : [],
        }, [this.topBoundary, ...this.$slots.default?.() ?? [], this.bottomBoundary]);
    },
    mounted() {
        const observerOptions = {
            root: this.$el,
            threshold: [0, 1],
        };

        const topBoundaryObserver = new IntersectionObserver(entries => {
            this.topBoundaryVisible = entries[0].intersectionRatio > 0;
        }, observerOptions);
        topBoundaryObserver.observe(this.topBoundary.el);

        const bottomBoundaryObserver = new IntersectionObserver(entries => {
            this.bottomBoundaryVisible = entries[0].intersectionRatio > 0;
        }, observerOptions);
        bottomBoundaryObserver.observe(this.bottomBoundary.el);
    },
    computed: {
        isOverflowing() {
            return !this.topBoundaryVisible || !this.bottomBoundaryVisible;
        },
    },
};